import { render, staticRenderFns } from "./KarmaCategoryView.vue?vue&type=template&id=4dd45f34&scoped=true&"
import script from "./KarmaCategoryView.vue?vue&type=script&lang=js&"
export * from "./KarmaCategoryView.vue?vue&type=script&lang=js&"
import style0 from "./KarmaCategoryView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./KarmaCategoryView.vue?vue&type=style&index=1&id=4dd45f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd45f34",
  null
  
)

export default component.exports